<script setup>
import { ref, computed, onMounted, watch } from 'vue';
import { useRequestsStore } from '@/stores/storeRequests';
import { useSettingsStore } from '@/stores/storeSettings';
import { useModals } from '@/composables/useModals';
import { RouterLink } from 'vue-router';

const storeRequests = useRequestsStore();
const storeSettings = useSettingsStore();
const { openModal } = useModals();

const tickeWeekly = ref(null);

const tickeGrand = ref(null);
const isEndWeeklyDraw = computed(() => storeSettings.settings?.is_all_weekly_draws_completed );
const isEndGrandDraw = computed(() => storeSettings.settings?.is_grand_draw_completed  );

const getPrizeUserCounter = (type, key) => {
	return storeRequests.listUserPrizes.filter((item) => item.prize.type === type)
		.reduce((acc, item) => acc + item[key], 0) || 0;
}

const formatData = (date) => {
	if(!date) return 'не определенa'
	const formattedData = date.split('-').reverse();
	return `${formattedData[0]}.${formattedData[1]}.${formattedData[2]}г.`
}


const getIdPeriodPrize = async (type) => {
	const [ prize ] = await storeRequests.getPrizes(type);
	if(!prize) return;

	const { id, title, current_period:currentPeriod } = prize

	return { id, title, currentPeriod }
}


const listPrizesForTicket = computed(() => ({
	weekly: {
		id: tickeWeekly.value.id ,
		title: 'Покупка билета на&nbsp;участие в&nbsp;еженедельном розыгрыше',
		image: new URL("@/assets/img/prizes/gift_ticket_weekly.webp", import.meta.url).href,
		points: 500,
		description: `
			Вы покупаете билет для участия в еженедельном розыгрыше за период с ${formatData(tickeWeekly.value?.currentPeriod?.start_at)} по ${formatData(tickeWeekly.value?.currentPeriod?.end_at)}
			Дата розыгрыша: ${formatData(tickeWeekly.value?.currentPeriod?.draft_at)}
			Разыгрываемый приз: Сертификат OZON   номиналом 1 000 рублей.
		`,
		response: `
			Вы успешно приобрели билет для участия в еженедельном розыгрыше текущего периода.<br>
			Билет добавлен к розыгрышу и учитывается как отдельная заявка.
			Результаты будут опубликованы после проведения розыгрыша.
		`,
	},
	grand: {
		id: tickeGrand.value?.id,
		title: 'Покупка билета на&nbsp;участие в&nbsp;главном розыгрыше',
		image: new URL("@/assets/img/prizes/gift_ticket_grand.webp", import.meta.url).href,
		points: 5000,
		description: `
			Вы покупаете билет для участия в розыгрыше главного приза Greenfield Клуб.
			Дата розыгрыша: 22.12.2026 г.
			Разыгрываемый приз: 1 000 000 рублей на мечту.

		`,
		response: `
			Вы успешно приобрели билет для участия в розыгрыше главного приза Greenfield Клуб.<br>
			Билет добавлен к розыгрышу и учитывается как отдельная заявка.
			Розыгрыш состоится 22 декабря 2026 года.
		`,
	}
}))


onMounted(async () => {
	tickeWeekly.value = await getIdPeriodPrize('ticket_for_weekly');
	tickeGrand.value = await getIdPeriodPrize('ticket_for_grand');
})
</script>
<template>
	<div class="user-tickets">
		<h2 class="user-tickets__title profile-title">Билеты для участия в розыгрышах</h2>
		<div class="user-tickets__inner">
			<div class="user-tickets__block">
				<div class="user-tickets__box">
					<h3 class="user-tickets__prize-name">Еженедельный приз</h3>
					<div class="user-tickets__desc" v-if="!isEndWeeklyDraw">
						<p>Дата розыгрыша {{ formatData(tickeWeekly?.currentPeriod?.draft_at) }}</p>
						<p>Ваши билеты на участие: <span>{{ getPrizeUserCounter("ticket_for_weekly", "current_period_count") }}</span></p>
					</div>
					<div class="user-tickets__desc" v-else>
						<p>Итоги подведены победители опубликованы</p>
					</div>
					<div class="user-tickets__info count-info" v-if="!isEndWeeklyDraw">
						<span class="yellow">
							500 <svg width="24" height="24"><use href="#leaf"></use></svg>
						</span> =
						<span class="white">1 билет</span>
					</div>
					<RouterLink to="/#winners" class="user-tickets__btn btn --small" v-if="isEndWeeklyDraw && !storeSettings.isTelegramPage">Посмотреть</RouterLink>
					<button @click="openModal('modalTicketExchange', { content: listPrizesForTicket.weekly, size: 'w740' })" class="user-tickets__btn btn --small" v-if="!isEndWeeklyDraw && storeSettings.statusStockActive">Обменять</button>

				</div>
				<div class="user-tickets__image-inner --weekly">
					<h3 class="user-tickets__prize-name --mobile">Еженедельный приз</h3>
					<h5 class="user-tickets__image-name">Сертификат OZON 1000 рублей</h5>
					<div class="user-tickets__image" data-count="x10">
						<img class="" width="121" height="76" src="@/assets/img/prizes/prize_ozon.webp" alt="изображение" />
					</div>
				</div>
			</div>
			<div class="user-tickets__block">
				<div class="user-tickets__box">
					<h3 class="user-tickets__prize-name">Главный приз</h3>
					<div class="user-tickets__desc" v-if="!isEndGrandDraw">
						<p>Дата розыгрыша 22.12.2026г.</p>
						<p>Ваши билеты на участие: <span>{{ getPrizeUserCounter("ticket_for_grand", "counter") }}</span></p>
					</div>
					<div class="user-tickets__desc" v-else>
						<p>Дата розыгрыша 22.12.2026г.</p>
						<p>Итоги подведены победители опубликованы</p>
					</div>
					<div class="user-tickets__info count-info" v-if="!isEndGrandDraw">
						<span class="yellow">
							5000 <svg width="24" height="24"><use href="#leaf"></use></svg>
						</span> =
						<span class="white">1 билет</span>
					</div>
					<RouterLink to="/#winners"  class="user-tickets__btn btn --small" v-if="isEndGrandDraw && !storeSettings.isTelegramPage">Посмотреть</RouterLink>
					<button @click="openModal('modalTicketExchange', { content: listPrizesForTicket.grand, size: 'w740' })" class="user-tickets__btn btn --small" v-if="!isEndGrandDraw && storeSettings.statusStockActive">Обменять</button>

				</div>
				<div class="user-tickets__image-inner --grand">
					<h3 class="user-tickets__prize-name --mobile">Главный приз</h3>
					<div class="user-tickets__image">
						<img class="" width="135" height="100" src="@/assets/img/prizes/prize_grand.webp" alt="изображение" />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<style lang="scss" scoped>
@use "@/assets/scss/base/vars";

.user-tickets {
	@extend .base-bg-light;
	border: 1px solid var(--border-accent-2-3);
	border-radius: 4rem;
	padding: 4.5rem 4rem 5rem 4rem;
	backdrop-filter: blur(15.399999618530273px);
	box-shadow: inset 0 13px 35px 0 rgba(255, 255, 255, 0.14), 0 16px 33px 0 rgba(0, 0, 0, 0.25);
	background-image: url("@/assets/img/tickets_bg.webp");
	background-repeat: no-repeat;
	background-position: 12% 100%; /* x y*/
	background-size: 38rem; /* w h*/
	@media (max-width: vars.$xx) {
		background-image: none;
	}

	@media (max-width: vars.$x480) {
		border-radius: 2.4rem;
		padding: 2.7rem 2rem 3rem 2.4rem;
	}
	&__title {
		margin-bottom: 1.6rem;
		@media (max-width: vars.$x480) {
			margin-bottom: 0.5rem;
		}
	}

	&__inner {
		display: grid;
		grid-template-columns: repeat(2, 1fr);
		@media (max-width: vars.$t) {
			grid-template-columns: 1fr;
		}
		@media (max-width: vars.$x480) {
			gap: 2rem;
		}
	}

	&__block {
		display: grid;
		grid-template-columns: 1fr 16.6rem;
		gap: 1rem;
		padding-top: 1.5rem;
		padding-right: 3rem;
		padding-bottom: 4rem;
		@media (max-width: vars.$t) {
			padding-right: 0px;
		}
		@media (max-width: vars.$x480) {
			grid-template-columns: 1fr;
			padding-top: 0px;
			padding-right: 0px;
			padding-bottom: 0px;
			gap: 4.8rem;
		}

		&:last-child {
			padding-right: 0;
			padding-left: 3.8rem;
			border-left: 1px solid var(--border-accent-2-3);
			@media (max-width: vars.$t) {
				padding-left: 0;
				border-color: transparent;
			}
			@media (max-width: vars.$x480) {
				padding-left: 0px;
				padding-top: 1.5rem;
				border-top: 1px solid var(--border-accent-2-3);
			}
		}
	}

	&__box {
		height: 100%;
		display: flex;
		flex-direction: column;
	}

	&__prize-name {
		font-family: var(--second-family);
		font-weight: 700;
		font-size: 2rem;
		line-height: 110%;
		text-transform: uppercase;
		color: var(--text-accent-2-100);
		margin-bottom: 1rem;
		@media (max-width: vars.$x480) {
			display: none;
		}
		&.--mobile {
			display: none;
			@media (max-width: vars.$x480) {
				display: block;
			}
		}
	}

	&__desc {
		font-weight: 500;
		font-size: 1.6rem;
		line-height: 140%;
		margin-bottom: 1.5rem;
		@media (max-width: vars.$x480) {
			margin-bottom: 1.2rem;
		}
		p {
			&:not(:last-child) {
				margin-bottom: 1rem;
			}

			span {
				display: block;
				font-family: var(--second-family);
				font-weight: 700;
				font-style: Bold;
				font-size: 2.8rem;
				line-height: 110%;
				letter-spacing: 0%;
				text-transform: uppercase;
				color: var(--fill-accent-2-1);
			}
		}
	}
	&__info {
		margin-bottom: 10px;
	}
	&__btn {
		min-height: 4.8rem;
		width: fit-content;
		margin-top: auto;
		@media (max-width: vars.$x480) {
			width: 100%;
		}
	}

	&__image-inner {
		display: grid;
		place-content: center;
		@media (max-width: vars.$x480) {
			grid-row: 1 / 2;
			place-content: start;
		}
		&.--weekly {
			place-content: start;
			.user-tickets__image {
				position: relative;
				width: 12.1rem;
				margin: 0 auto;
				@media (max-width: vars.$x480) {
					margin: 0 0 0 20px;
				}
				&::before {
					position: absolute;
					content: attr(data-count);
					display: flex;
					align-items: center;
					justify-content: center;
					font-weight: 700;
					font-size: 1.6rem;
					line-height: 140%;
					text-align: center;
					color: var(--text-inverse-100);
					border: 1px solid var(--border-accent-2-1);
					border-radius: 1.8rem;
					background: var(--fill-accent-1-1);
					width: 4.7rem;
					height: 2.9rem;
					bottom: -20%;
					right: -7%;
					@media (max-width: vars.$x480) {
						bottom: -17%;
						right: -13%;
					}
				}
			}
		}
		&.--grand {
			.user-tickets__image {
				width: 13.5rem;
				@media (max-width: vars.$x480) {
					margin: 3.7rem 0 -2rem 2rem;
				}
			}
		}
	}

	&__image-name {
		font-weight: 500;
		font-size: 1.6rem;
		line-height: 140%;
		color: var(--text-accent-2-100);
		margin-bottom: 1.9rem;
		@media (max-width: vars.$x480) {
			margin-bottom: 4.8rem;
		}
	}

	&__image {
	}
}
</style>
